import React, { forwardRef, useCallback, useState } from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";

export interface ListItemButtonProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}

const DefaultStyle: React.CSSProperties = {
  // display: "flex",
  // padding: "6px 16px",
  // gap: "8px",
  // minWidth: "200px",
  // boxSizing: "border-box",
  // color: "var(--tea-color-text-primary)",
  // cursor: "pointer",
};

const DefaultStyleHover: React.CSSProperties = {
  // backgroundColor: "var(--tea-color-bg-primary-hover)",
};

export const ListItemButton = forwardRef(
  (
    { children, className, style, ...restProps }: ListItemButtonProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const { classPrefix } = useConfig();

    const [isHover, setIsHover] = useState(false);
    // const handleMouseEnter = useCallback(() => {
    //   setIsHover(true);
    // }, []);
    // const handleMouseLeave = useCallback(() => {
    //   setIsHover(false);
    // }, []);

    return (
      <div
        className={classNames(`${classPrefix}-list__item-button`, className)}
        style={{
          ...DefaultStyle,
          ...style,
          ...(isHover ? DefaultStyleHover : {}),
        }}
        ref={ref}
        {...restProps}
        // onMouseEnter={handleMouseEnter}
        // onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
    );
  }
);

ListItemButton.displayName = "ListItemButton";
